import { ReactElement } from 'react';

interface SparklesIconProps {
  className?: string;
  color?: string;
  size?: number;
}

export const SparklesIcon = ({
  className,
  color,
  size,
}: SparklesIconProps): ReactElement => {
  const fillColor = color ?? '#004C97';
  const finalSize = size ?? 12;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={finalSize}
      height={finalSize}
      viewBox="0 0 12 12"
      fill="none"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <g clipPath="url(#clip0_27269_6917)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.00039 0.498657C6.23371 0.498674 6.45986 0.580458 6.63936 0.729517C6.81851 0.878349 6.93997 1.08511 6.98301 1.31399L7.50859 4.09309L7.51709 4.12971C7.53973 4.21423 7.58413 4.29164 7.64629 4.35383C7.71733 4.42488 7.80832 4.47284 7.90703 4.49153L10.685 5.01682C10.9143 5.05967 11.1218 5.18156 11.2709 5.36106C11.42 5.54057 11.5015 5.76668 11.5015 6.00002C11.5014 6.23336 11.42 6.45948 11.2709 6.63899C11.1218 6.81844 10.9146 6.94007 10.6853 6.98293L10.685 6.98264L7.90732 7.50823C7.8086 7.52691 7.71734 7.57487 7.64629 7.64592C7.57524 7.71699 7.52726 7.80793 7.50859 7.90667L6.98301 10.6846L6.9833 10.6849C6.94043 10.9142 6.81882 11.1215 6.63936 11.2705C6.45986 11.4196 6.23371 11.5011 6.00039 11.5011C5.76708 11.5011 5.54092 11.4196 5.36143 11.2705C5.18195 11.1215 5.06005 10.9142 5.01719 10.6849L4.49189 7.90696C4.47322 7.80822 4.42526 7.71698 4.3542 7.64592C4.292 7.58377 4.21459 7.53937 4.13008 7.51672L4.09346 7.50823L1.31553 6.98264C1.0862 6.93979 0.878958 6.81844 0.729883 6.63899C0.580821 6.45949 0.49904 6.23335 0.499023 6.00002C0.499023 5.76668 0.580805 5.54058 0.729883 5.36106C0.860314 5.20402 1.03525 5.09121 1.23057 5.03674L1.31553 5.01682L4.09346 4.49153L4.13008 4.48333C4.21464 4.46067 4.29198 4.41604 4.3542 4.35383C4.42528 4.28275 4.47323 4.19187 4.49189 4.09309L5.01748 1.31399C5.06051 1.08508 5.18224 0.87836 5.36143 0.729517C5.54093 0.580436 5.76705 0.498674 6.00039 0.498657ZM6.0001 1.49973L5.47451 4.27883C5.41851 4.57515 5.27467 4.84782 5.06143 5.06106C4.87482 5.24766 4.64269 5.38126 4.38906 5.44924L4.2792 5.47415L1.5001 5.99973L4.2792 6.52561L4.38906 6.55081C4.64268 6.61879 4.87483 6.7524 5.06143 6.93899C5.27459 7.15218 5.4185 7.42469 5.47451 7.72092L6.0001 10.5L6.52598 7.72092C6.58199 7.42466 6.72616 7.1522 6.93936 6.93899C7.15255 6.72579 7.42503 6.58163 7.72129 6.52561L10.5004 6.00002L7.72129 5.47415C7.42508 5.41813 7.15254 5.27421 6.93936 5.06106C6.75277 4.87446 6.61916 4.64231 6.55117 4.3887L6.52598 4.27883L6.0001 1.49973Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.0002 8.49963C2.82859 8.49963 3.50014 9.17125 3.5002 9.99963C3.5002 10.8281 2.82862 11.4996 2.0002 11.4996C1.17186 11.4995 0.500195 10.828 0.500195 9.99963C0.500248 9.17132 1.1719 8.49975 2.0002 8.49963ZM2.0002 9.49983C1.72418 9.49994 1.50044 9.72361 1.50039 9.99963C1.50039 10.2757 1.72415 10.4996 2.0002 10.4997C2.27634 10.4997 2.50029 10.2758 2.50029 9.99963C2.50024 9.72354 2.27631 9.49983 2.0002 9.49983Z"
          fill={fillColor}
        />
        <path
          d="M10.0003 0.499829C10.2764 0.499829 10.5004 0.723784 10.5004 0.999927V1.50002H11.0005C11.2766 1.50008 11.5003 1.72401 11.5003 2.00012C11.5003 2.27623 11.2766 2.50017 11.0005 2.50022H10.5004V3.00002C10.5003 3.27612 10.2764 3.49983 10.0003 3.49983C9.72423 3.49977 9.50025 3.27609 9.5002 3.00002V2.50022H9.00039C8.72425 2.50022 8.50029 2.27626 8.50029 2.00012C8.50029 1.72398 8.72425 1.50002 9.00039 1.50002H9.5002V0.999927C9.5002 0.723821 9.7242 0.499888 10.0003 0.499829Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_27269_6917">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
